import { createContext, useContext } from "react";

const TableContext = createContext();
const { Provider, Consumer } = TableContext;

function useTable() {
  const context = useContext(TableContext);

  return context;
}

export { Provider, Consumer, useTable };
